(function() {
  angular.module('common')
  .controller('historyController', ['historyService', '$http', '$state','secSecurityService', '$rootScope', '$timeout', '$filter', 'claimService','$scope',
    function (historyService, $http, $state,securityService, $rootScope, $timeout, $filter, claimService, $scope) {
      var vm = this;
      vm.isNavCollapsed = true;
      vm.navigate = navigate;
      vm.claimSearchEvents = ['Member Claim Search','EFT Number Search','Check Number Search','Date Range Search','DSO Date Range Search'];
      let cardsId = 0;
      vm.showHistory=false;
      vm.dsoClaimSearchDisplay = true;
      vm.cardsInfo = [
                      {id: cardsId++, title: 'Benefits & Eligibility', eventDataRef: () => {return vm.filteredBenefitHistories;},
                       columns: [{header:'Name', field: 'name', filter: ''}, {header:'Date of Birth', field: 'birthDate', filter: 'portalDate'}],
                       layoutClasses: "col-md-6 col-lg-4"
                     },
                      {id: cardsId++, title: 'Claims', eventDataRef: () => {return vm.filteredClaimHistories;},
                       columns: [{header:'Name', field: 'name', filter: ''}, {header:'Date of Service', field: 'birthDate', filter: 'portalDate'}],
                       layoutClasses: "col-md-6 col-lg-4"
                     },
                      {id: cardsId++, title: 'Claim Search By Member ID', eventDataRef: () => {return vm.filteredClaimsSearchHistories;},
                       columns: [{header:'Name', field: 'name', filter: ''}, {header:'Date of Birth', field: 'birthDate', filter: 'portalDate'}],
                       layoutClasses: "col-md-6 col-lg-4"
                     },
                     {id: cardsId++, title: 'Claim Search By EFT Number', eventDataRef: () => {return vm.filteredClaimsEftSearchHistories;},
                      columns: [{header:'EFT', field: 'eftNumber', filter: ''}],
                      layoutClasses: "col-md-6 col-lg-3"
                    },
                    {id: cardsId++, title: 'Claim Search By Check Number', eventDataRef: () => {return vm.filteredChkClaimsSearchHistories;},
                     columns: [{header:'Check Number', field: 'checkNumber', filter: ''}],
                     layoutClasses: "col-md-6 col-lg-3"
                     },
                     {id: cardsId++, title: 'Claim Search By Date Range', eventDataRef: () => {return vm.filteredDateClaimsSearchHistories;},
                      columns: [{header:'Date Range', field: 'dateRange', filter: ''}],
                      layoutClasses: "col-md-6 col-lg-3"
                    },
                    {id: cardsId++, title: 'Claim Search By Date Range', eventDataRef: () => {return vm.filteredDateClaimsSearchHistoriesDsoProv;},
                        columns: [{header:'Date Range', field: 'dateRange', filter: ''}],
                         layoutClasses: "col-md-6 col-lg-3"
                    }
                    ];

        securityService.hasAnyAuthority('DSO_ADMIN_USER').then((isDsoAdmin) => {
            if (isDsoAdmin) {
                vm.dsoClaimSearchDisplay = false;
                vm.dsoAdminUser = isDsoAdmin;
                vm.cardsInfo[5].columns.push({header:'Locations', field: 'displayLocations', filter: (locns) => {return locns.join(", ");} , toolTip: (locns)=>{return locns.join(",\n");}});
                vm.cardsInfo[5].layoutClasses =  "col-md-6 col-lg-6";
            }
        });

      //monitor filteredHistory arrays' length
      $scope.$watchGroup(_.map(vm.cardsInfo,(c,i)=> {return  '(vm.cardsInfo['+i+'].eventDataRef()).length'; }),(vals) => {
          vm.showHistory = _.sumBy(vals,(v)=>{return v;}) > 0;
      });

      function populateHistory(data) {
        if (data.authorities) {
          $http.get('/me/history?historyType=claim').then(function(result) {
            historyService.claimHistories = _.filter(_.uniqWith(result.data.histories, function(a,b) {
              return a.eventData.name == b.eventData.name && a.eventData.birthDate === b.eventData.birthDate && a.eventData.eventName == b.eventData.eventName;
            }),function(record) {
              return record.eventData.refId;
            });
            vm.filteredClaimHistories = historyService.claimHistories;
            historyService.maxSize = result.data.size;
          });
          getHistory('claimsSearch',['name','birthDate','eventName'],'refId').then(function(result) {
             historyService.claimsSearchHistories = result;
             vm.filteredClaimsSearchHistories = historyService.claimsSearchHistories;
             historyService.maxSize = result.size;
          });
          getHistory('eftSearch',['eftNumber','eventName'],'eftNumber').then(function(result) {
             historyService.claimsEftSearchHistories = result;
             vm.filteredClaimsEftSearchHistories = historyService.claimsEftSearchHistories;
             historyService.maxSize = result.size;
          });
          getHistory('checkNumberSearch',['checkNumber','eventName'],'checkNumber').then(function(result) {
             historyService.claimsCheckNumSearchHistories = result;
             vm.filteredChkClaimsSearchHistories = historyService.claimsCheckNumSearchHistories;
             historyService.maxSize = result.size;
          });
          getHistory('dateRangeClaimsSearch',['fromDate','toDate','taxId','locations','eventName'],'criteriaHash').then(function(result) {
             historyService.claimsDateRangeSearchHistories = result;
             vm.filteredDateClaimsSearchHistories = historyService.claimsDateRangeSearchHistories;
             _.each(vm.filteredDateClaimsSearchHistories, function(event) {
                 event.eventData.dateRangeFrom = $filter('portalDate')(event.eventData.fromDate);
                 event.eventData.dateRangeTo = $filter('portalDate')(event.eventData.toDate);
                 event.eventData.dateRange = event.eventData.dateRangeFrom + ' - ' + event.eventData.dateRangeTo;
                 event.eventData.displayLocations = [];
                 if (vm.dsoAdminUser && event.eventData.taxId) {
                    claimService.getFilteredTaxIdLocations(event.eventData.taxId, event.eventData.locations).then(function(result) {
                     event.eventData.displayLocations = result;
                   });
                 }
             });
             historyService.maxSize = result.size;
          });
          getHistory('dateRangeClaimsSearchDsoProv',['fromDate','toDate','eventName'],'criteriaHash').then(function(result) {
                historyService.claimsDateRangeSearchHistoriesDsoProv = result;
                vm.filteredDateClaimsSearchHistoriesDsoProv = historyService.claimsDateRangeSearchHistoriesDsoProv;
                _.each(vm.filteredDateClaimsSearchHistoriesDsoProv, function(event) {
                    event.eventData.dateRangeFrom = $filter('portalDate')(event.eventData.fromDate);
                    event.eventData.dateRangeTo = $filter('portalDate')(event.eventData.toDate);
                    event.eventData.dateRange = event.eventData.dateRangeFrom + ' - ' + event.eventData.dateRangeTo;
                });
                historyService.maxSize = result.size;
          });
          $http.get('/me/history?historyType=benefit').then(function(result) {
            historyService.benefitHistories = _.filter(_.uniqWith(result.data.histories, function(a,b) {
              return a.eventData.name == b.eventData.name && a.eventData.birthDate === b.eventData.birthDate && a.eventData.eventName == b.eventData.eventName;
            }),function(record) {
              return record.eventData.refId;
            });
            vm.filteredBenefitHistories = historyService.benefitHistories;
          });
        }
      }

      function getHistory(historyType, compProperties, filterProperty) {
        if (angular.isArray(compProperties) && filterProperty) {
            return $http.get('/me/history?historyType='+historyType).then(function(result) {
                let uniqueRecords = _.uniqWith(result.data.histories, function(a,b) {
                  let unique = true;
                  _.each(compProperties, function(p) {
                      unique = unique &&
                               ((angular.isArray(a.eventData[p]) || angular.isArray(b.eventData[p])) ? _.isEqual(a.eventData[p],b.eventData[p]) : (a.eventData[p] == b.eventData[p]));
                      return unique;
                  });
                });
                return _.filter(uniqueRecords, (r) => r.eventData[filterProperty]);
            });
        }
      }

      function navigate(history) {
        vm.isNavCollapsed = true;
        if(history.eventData.claimId) {
        	$rootScope.rootFlag = false;
            $state.go('claimLines',{'claimId':history.eventData.claimId});
        } else if(_.find(vm.claimSearchEvents,(e) => e === history.eventData.eventName)) {
            claimService.historyToModel(history.eventData);
            $state.go('claimsSearch');
        } else {
            $state.go('benefits.dashboard', {'referenceId': history.eventData.refId, 'subscriberId': history.eventData.subscriberId, 'dateOfBirth': history.eventData.birthDate, 'expandAssociatedMembers': false});
        }
      }

      $rootScope.$on('lookUpHistory', function() {
        populateHistory({authorities:true});
      });

      securityService.getLoggedInUser().then(function(data){
        populateHistory(data);
      });

    }
  ]);
})();
